export default {
  name: 'chat-manager',
  translationKey: 'chat-manager-module',
  routePrefix: 'chat-manager',
  routeNamePrefix: 'chat-manager',
  directRoutesAvailable: true,
}
